import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getProducts() {
    yield takeEvery(actions.FETCH_PRODUCTS_REQUESTED, function* (action) {
        try {
          const products = yield call(actions.getProducts, action.payload);

          yield put({ type: actions.FETCH_PRODUCTS_SUCCEEDED, products });
        } catch (error) {
          yield put({ type: actions.FETCH_PRODUCTS_FAILED, error: error.message });
        }
    });
}


export function* getProduct() {
    yield takeEvery(actions.FETCH_PRODUCT_REQUESTED, function* (action) {
        try {
            const product = yield call(actions.getProduct, action.payload);
            yield put({ type: actions.FETCH_PRODUCT_SUCCEEDED, product: product.item_info });
        } catch (error) {
            yield put({ type: actions.FETCH_PRODUCT_FAILED, error: error.message });
        }
    });
}

export function* searchProducts() {
  yield takeEvery(actions.SEARCH_PRODUCT_REQUESTED, function* (action) {
    try {
      const products = yield call(actions.searchProducts, action.payload);
      yield put({ type: actions.SEARCH_PRODUCT_SUCCEEDED, products });
    } catch (error) {
      yield put({ type: actions.SEARCH_PRODUCT_FAILED, error: error.message });
    }
  });
}


export function* deleteProduct() {
  yield takeEvery(actions.DELETE_PRODUCT_REQUESTED, function* (action) {
      try {
          const product = yield call(actions.deleteProduct, action.payload);
          yield put({ type: actions.DELETE_PRODUCT_SUCCEEDED, productDeleted: product });
      } catch (error) {
          yield put({ type: actions.DELETE_PRODUCT_FAILED, error: error.message });
      }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getProducts),
    fork(searchProducts),
    fork(getProduct),
    fork(deleteProduct)
  ]);
}
